<template>
  <section class="privacy-persional-protection">
    <div class="persional-protection-container">
      <section
        class="persional-protection-block persional-infor-block wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      >
        <div class="persional-protection-text-intro">
          <p class="title">个人信息保护</p>
          <p class="sub-title">互联网“隐身”</p>
        </div>
        <div class="protection-learn-more" :class="showPersionalText ? 'show-protection-learn-text' : ''">
          <div class="protection-learn-more-button" @click="showPersionalText = !showPersionalText">
            <span>了解更多</span>
            <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.001 0h-1v6.001H0v1h6.001V13h1V7.001H13v-1H7.001V0z"
                fill="#fff"
              />
            </svg>
          </div>
          <div class="protection-learn-more-text">
            对应用开启保护后，在需要读取“通话记录”
            “联系人”等敏感信息时，系统将自动提交空白信息，充分保障你的隐私安全而不影响APP正常使用。
          </div>
        </div>
        <div class="persional-infor-lottie" @mouseenter="lottieAnimationPlay('persionalAnimation')"></div>
      </section>
      <section
        class="persional-protection-block protection-application-block wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      >
        <div class="persional-protection-text-intro">
          <p class="title">应用锁</p>
          <p class="sub-title">为你的应用上把锁</p>
        </div>
        <div class="protection-learn-more" :class="showApplicationText ? 'show-protection-learn-text' : ''">
          <div class="protection-learn-more-button" @click="showApplicationText = !showApplicationText">
            <span>了解更多</span>
            <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.001 0h-1v6.001H0v1h6.001V13h1V7.001H13v-1H7.001V0z"
                fill="#fff"
              />
            </svg>
          </div>
          <div class="protection-learn-more-text">
            对任意应用都能进行加锁，加锁后的应用需要输入密码查看。没有你的许可，谁都无权窥探你的秘密。
          </div>
        </div>
        <img
          v-lazy="require('../../assets/zh/privacy/persional-application-lock.png')"
          alt="ColorOS 11"
          class="persional-application"
        />
      </section>
      <section
        class="persional-protection-block protection-seperation-block wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      >
        <div class="persional-protection-text-intro">
          <p class="title">系统分身</p>
          <p class="sub-title">只有你知道的影子空间</p>
        </div>
        <div class="protection-learn-more" :class="showSeperationText ? 'show-protection-learn-text' : ''">
          <div class="protection-learn-more-button" @click="showSeperationText = !showSeperationText">
            <span>了解更多</span>
            <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.001 0h-1v6.001H0v1h6.001V13h1V7.001H13v-1H7.001V0z"
                fill="#fff"
              />
            </svg>
          </div>
          <div class="protection-learn-more-text">
            “分身”系统中的应用和数据与主空间完全隔离，入口也可以完美隐藏，只能通过特定指纹或锁屏密码进入，完全无痕隐藏使用内容。
            <sup>3</sup>
          </div>
        </div>
        <div class="persional-seperation">
          <img v-lazy="require('../../assets/zh/privacy/persional-seperation-0.png')" alt="ColorOS 11" />
          <img v-lazy="require('../../assets/zh/privacy/persional-seperation-1.png')" alt="ColorOS 11" />
        </div>
      </section>
      <section
        class="persional-protection-block protection-secret-box-block wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      >
        <div class="persional-protection-text-intro">
          <p class="title">私密保险箱</p>
          <p class="sub-title">
            把秘密锁进“保险柜”
          </p>
        </div>
        <div class="protection-learn-more" :class="showSecretBoxText ? 'show-protection-learn-text' : ''">
          <div class="protection-learn-more-button" @click="showSecretBoxText = !showSecretBoxText">
            <span>了解更多</span>
            <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.001 0h-1v6.001H0v1h6.001V13h1V7.001H13v-1H7.001V0z"
                fill="#fff"
              />
            </svg>
          </div>
          <div class="protection-learn-more-text">
            无论是私密照片还是音频文档，都能安心“锁”起来。加密后的文件只能通过私密保险箱读取，其他应用无权获取。
          </div>
        </div>
        <div class="protection-secret-box-lottie" @mouseenter="lottieAnimationPlay('secretBoxAnimation')"></div>
      </section>
    </div>
  </section>
</template>
<script>
import lottie from 'lottie-web/build/player/lottie_svg.min';
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';

export default {
  inject: ['vm'],
  data() {
    return {
      showPersionalText: false,
      showApplicationText: false,
      showSeperationText: false,
      showSecretBoxText: false
    };
  },
  mounted() {
    this.loadAnimation();
    if (this.vm.isMobile) {
      this.mobileLottieAnimationPlay();
    }
  },
  methods: {
    loadAnimation() {
      this.scene = new ScrollMagic.Scene({
        triggerElement: '.privacy-persional-protection',
        triggerHook: 1,
        duration: 5 * window.innerHeight,
        offset: -2 * window.innerHeight
      })
        .addTo(Controller)
        .on('enter', () => {
          if (this.lottieLoaded) return;
          this.lottieLoaded = true;
          this.scene.destroy(true);
          Promise.all([import('./lottie/protectionPersional.json'), import('./lottie/protectionSecretBox.json')]).then(
            ([persionalAnimationData, secretBoxAnimationData]) => {
              secretBoxAnimationData.assets.forEach((item, index) => {
                if (item.p) {
                  // get from https://github.com/facebook/jest/issues/7271 and jianshu.com/p/78f7b19932cb
                  item.u = '';
                  item.p = require('./lottie/protectionSecretBoxImages/img_' + index + '.png');
                }
              });
              this.loadAnimationed = true;
              this.persionalAnimation = lottie.loadAnimation({
                container: document.querySelector('.persional-infor-lottie'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                animationData: persionalAnimationData
              });

              this.secretBoxAnimation = lottie.loadAnimation({
                container: document.querySelector('.protection-secret-box-lottie'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                animationData: secretBoxAnimationData
              });
            }
          );
        });
    },
    lottieAnimationPlay(type) {
      if (this[type + 'Play'] || !this.loadAnimationed) return;
      this[type + 'Play'] = true;
      this[type].play();
    },
    mobileLottieAnimationPlay() {
      const lottieAnimationPlayCheck = type => {
        if (this.loadAnimationed) {
          this.lottieAnimationPlay(type);
        } else {
          if (this[type + 'MobileTimer']) clearTimeout(this[type + 'MobileTimer']);
          this[type + 'MobileTimer'] = setTimeout(() => {
            lottieAnimationPlayCheck(type);
          }, 100);
        }
      };
      const inforScenen = new ScrollMagic.Scene({
        triggerElement: '.persional-infor-block',
        triggerHook: 1,
        offset: 400
      })
        .addTo(Controller)
        .on('enter', () => {
          setTimeout(() => {
            if (inforScenen.progress() === 1) {
              lottieAnimationPlayCheck('persionalAnimation');
            }
          }, 200);
        });
      const secretBoxScene = new ScrollMagic.Scene({
        triggerElement: '.protection-secret-box-block',
        triggerHook: 1,
        offset: 500
      })
        .addTo(Controller)
        .on('enter', () => {
          setTimeout(() => {
            if (secretBoxScene.progress() === 1) {
              lottieAnimationPlayCheck('secretBoxAnimation');
            }
          }, 200);
        });
    }
  }
};
</script>
